export default function oauthSetup (currentRootUrl, domain) {
  return {
    domain,
    scope: ['email', 'openid', 'aws.cognito.signin.user.admin'],
    redirectSignIn: `${currentRootUrl}auth/login`,
    redirectSignOut: `${currentRootUrl}auth/logout`,
    responseType: 'code'
  }
}
